// eslint-disable-next-line import/no-cycle
import { IRequestErrorServerResponse } from 'Api';
import { BaseFormModelErrorHandler } from './BaseFormModelErrorHandler';

const EMAIL_ERROR_TEXT = 'Your email is considered as invalid. Please re-check your email. If it is correct, <a href="/company/contact-us">contact us</a> please.';

interface IHubSpotFieldError {
  errorType?: string,
  message?: string,
}

export class BaseHubSpotFormModelErrorHandler extends BaseFormModelErrorHandler {
  getErrorMessageByServerResponse(serverResponse?: IRequestErrorServerResponse & { errors?: IHubSpotFieldError[] } | string) {
    // Handle error messages from hubspot
    if (typeof serverResponse !== 'string' && serverResponse?.errors && Array.isArray(serverResponse.errors)) {
      const errors: string[] = [];
      // each message
      serverResponse.errors.forEach((fieldError: IHubSpotFieldError) => {
        // If it's an email error, change to a const text
        if (fieldError?.errorType === 'INVALID_EMAIL') errors.push(EMAIL_ERROR_TEXT);
        // otherwise, push message to array
        else if (fieldError?.message) errors.push(fieldError.message);
      });
      // join messages.
      // Message from super call is skipped
      return errors.join('. ');
    }
    // If no message, try to get to call super method
    return super.getErrorMessageByServerResponse(serverResponse);
  }
}
